enum Types {

  CAUTION = 'caution',
  DANGER = 'danger',
  NEUTRAL = 'neutral',
  NOTICE = 'notice',
  SAFETY = 'safety',
  WARNING = 'warning',

}

export default Types;
